var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#233544",
    fillRule: "evenodd",
    d: "M10.705 3.519c-.67 0-1.24.466-1.4 1.094h5.382a1.453 1.453 0 0 0-1.4-1.094h-2.582Zm5.502 1.094h1.981C20.29 4.613 22 6.344 22 8.47c0 0-.06.9-.08 2.154a.33.33 0 0 1-.13.255c-.48.355-.92.65-.96.67-1.661 1.113-3.591 1.897-5.647 2.287a.318.318 0 0 1-.335-.163 3.296 3.296 0 0 0-2.853-1.649 3.35 3.35 0 0 0-2.872 1.643.319.319 0 0 1-.333.16 15.49 15.49 0 0 1-5.62-2.269l-.96-.668a.286.286 0 0 1-.13-.243C2.05 10.132 2 8.471 2 8.471c0-2.127 1.71-3.858 3.812-3.858h1.97C7.974 3.144 9.205 2 10.705 2h2.582c1.5 0 2.731 1.144 2.921 2.613Zm5.454 8.202-.04.02c-2.02 1.357-4.452 2.259-7.003 2.633a.753.753 0 0 1-.82-.546 1.816 1.816 0 0 0-1.781-1.378h-.03c-.85 0-1.561.547-1.781 1.378a.753.753 0 0 1-.82.546c-2.552-.374-4.983-1.275-7.004-2.632-.01-.01-.11-.071-.19-.02-.09.05-.09.171-.09.171l.07 5.165c0 2.127 1.7 3.848 3.801 3.848H18.02c2.1 0 3.801-1.721 3.801-3.848l.08-5.165s0-.121-.09-.172c-.05-.03-.11-.02-.15 0Zm-8.914 4.243c0 .426-.33.76-.75.76a.754.754 0 0 1-.75-.76v-1.306c0-.415.34-.76.75-.76.42 0 .75.345.75.76v1.306Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyFill);
export default __webpack_public_path__ + "static/media/company-fill.fc9f0badfee4ec0fab80418c51e50682.svg";
export { ForwardRef as ReactComponent };